import { parseRoleplayPreviewCharacters } from './chatSettingsRoleplayPreviewCharacters.cjs';
import {
    createInitialRoleplayPreviewItems,
    mergeRoleplayPreviewItems,
} from './chatSettingsRoleplayPreviewOrder.cjs';
import { startRoleplayInCurrentChat } from './roleplayToggle';

let roleplayPreviewReturnFocus = null;
const DEFAULT_ROLEPLAY_PREVIEW_FEED_LIMIT = 5;

export function updateRoleplayRowUI(previewImage, caption = '', roleplayScenarioKey = 'roleplay_scenario') {
    const $roleplayRow = jQuery('.chat-settings-single[data-type="roleplay"]');
    if (!$roleplayRow.length || !previewImage) return;

    $roleplayRow.removeClass('preview-is-hidden');

    const $previewTrigger = $roleplayRow.find('[data-roleplay-preview-trigger]').first();
    const $previewBg = $roleplayRow.find('.preview-bg');
    const $selectedOption = $roleplayRow.find(`select[name="${roleplayScenarioKey}"] option:selected`).first();

    if ($previewTrigger.length) {
        const captionDetails = parseRoleplayCaption(caption);
        $previewTrigger.attr({
            'data-roleplay-key': $selectedOption.val() || '',
            'data-roleplay-title': $selectedOption.attr('data-title') || captionDetails.title,
            'data-roleplay-description': $selectedOption.attr('data-description') || captionDetails.description,
            'data-roleplay-preview-image': previewImage,
            'data-roleplay-profile-url': $selectedOption.attr('data-profile-url') || '',
            'data-roleplay-adjust-url': $selectedOption.attr('data-adjust-url') || '',
            'data-roleplay-characters': $selectedOption.attr('data-characters') || '[]',
        });
    }

    if ($previewBg.length) {
        $previewBg.css('background', '');
        $previewBg.css({
            'background-image': `url('${previewImage}')`,
            'background-size': 'cover',
            'background-position': 'center'
        });
    }
}

function parseRoleplayCaption(caption = '') {
    if (!caption) {
        return {title: '', description: ''};
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = caption;
    const descriptionNode = wrapper.querySelector('small');
    const description = descriptionNode?.textContent?.trim() || '';
    descriptionNode?.remove();

    return {
        title: wrapper.textContent?.trim() || '',
        description,
    };
}

export function bindRoleplayPreviewModal() {
    const $document = jQuery(document);

    $document
        .off('click.roleplayPreviewOpen', '[data-roleplay-preview-trigger]')
        .off('click.roleplayPreviewNav', '[data-roleplay-preview-nav]')
        .off('click.roleplayPreviewStart', '[data-roleplay-preview-start]')
        .off('shown.bs.modal.roleplayPreview', '#growtypeChatRoleplayPreviewModal')
        .off('hidden.bs.modal.roleplayPreview', '#growtypeChatRoleplayPreviewModal')
        .on('click.roleplayPreviewOpen', '[data-roleplay-preview-trigger]', function (event) {
            event.preventDefault();
            openRoleplayPreviewModal(jQuery(this));
        })
        .on('click.roleplayPreviewNav', '[data-roleplay-preview-nav]', function (event) {
            event.preventDefault();
            const $button = jQuery(this);
            const direction = $button.attr('data-roleplay-preview-nav') === 'prev' ? -1 : 1;
            shiftRoleplayPreview(jQuery('[data-roleplay-preview-modal]').first(), direction);
        })
        .on('click.roleplayPreviewStart', '[data-roleplay-preview-start]', function (event) {
            event.preventDefault();
            const $button = jQuery(this);
            const $modal = $button.closest('[data-roleplay-preview-modal]');
            const previewData = $modal.data('roleplayPreviewData') || {};
            startRoleplayInCurrentChat({
                $button,
                roleplayScenario: String(previewData.key || '').trim(),
                $modalToClose: $modal,
            });
        })
        .on('shown.bs.modal.roleplayPreview', '#growtypeChatRoleplayPreviewModal', function () {
            const $modal = jQuery(this);
            const previewData = $modal.data('roleplayPreviewData');
            if (previewData) {
                syncRoleplayPreviewContent($modal, previewData);
            }
        })
        .on('hidden.bs.modal.roleplayPreview', '#growtypeChatRoleplayPreviewModal', function () {
            if (roleplayPreviewReturnFocus?.isConnected) {
                roleplayPreviewReturnFocus.focus();
            }
            roleplayPreviewReturnFocus = null;
        });
}

function openRoleplayPreviewModal($trigger) {
    const $modal = jQuery('[data-roleplay-preview-modal]').first();
    const previewData = normalizeRoleplayPreviewData({
        key: $trigger.attr('data-roleplay-key') || '',
        title: $trigger.attr('data-roleplay-title') || 'Roleplay',
        description: $trigger.attr('data-roleplay-description') || '',
        image: $trigger.attr('data-roleplay-preview-image') || '',
        characters: $trigger.attr('data-roleplay-characters') || '[]',
        profileUrl: $trigger.attr('data-roleplay-profile-url') || '',
        adjustUrl: $trigger.attr('data-roleplay-adjust-url') || '',
        startUrl: $trigger.attr('data-roleplay-start-url') || '',
    });

    if (!$modal.length || !previewData.image) {
        return;
    }

    roleplayPreviewReturnFocus = $trigger[0];
    $modal.data('roleplayPreviewData', previewData);

    if (!$modal.parent().is('body')) {
        $modal.appendTo('body');
    }

    syncRoleplayPreviewContent($modal, previewData);
    setRoleplayPreviewState($modal, {
        items: [previewData],
        activeIndex: 0,
        isLoading: true,
        hasMore: false,
        nextOffset: 0,
        nextCursor: null,
        feedKey: previewData.key,
        isPrefetching: false,
    });
    fetchRoleplayPreviewFeed($modal, {
        currentKey: previewData.key,
        currentPreviewData: previewData,
        offset: 0,
        append: false,
    });

    if (window.growtypeModal?.show) {
        window.growtypeModal.show('growtypeChatRoleplayPreviewModal', {stack: true});
    } else if (window.bootstrap?.Modal) {
        window.bootstrap.Modal.getOrCreateInstance($modal[0]).show();
    } else if (typeof jQuery.fn.modal === 'function') {
        $modal.modal('show');
    }
}

function syncRoleplayPreviewContent($modal, previewData) {
    $modal.find('[data-roleplay-preview-title]').text(previewData.title);
    $modal.find('[data-roleplay-preview-description]').text(previewData.description);
    $modal.find('[data-roleplay-preview-image]').css('background-image', `url('${previewData.image}')`);
    renderRoleplayPreviewCharacters($modal, previewData.characters);
    $modal.find('[data-roleplay-preview-start]').prop('disabled', !previewData.key);
    syncRoleplayPreviewAction($modal.find('[data-roleplay-preview-profile]'), previewData.profileUrl);
    syncRoleplayPreviewAction($modal.find('[data-roleplay-preview-adjust]'), previewData.adjustUrl);
    syncRoleplayPreviewNavigation($modal);
}

function renderRoleplayPreviewCharacters($modal, rawCharacters) {
    const characters = parseRoleplayPreviewCharacters(rawCharacters);
    const $wrapper = $modal.find('[data-roleplay-preview-characters-wrapper]').first();
    const $list = $modal.find('[data-roleplay-preview-characters]').first().empty();

    $wrapper.prop('hidden', characters.length === 0);

    characters.forEach((character) => {
        const $item = jQuery(character.url ? '<a>' : '<div>')
            .addClass('growtype-chat-roleplay-preview__character');

        if (character.url) {
            $item.attr('href', character.url);
        }

        const $avatar = jQuery('<span>')
            .addClass('growtype-chat-roleplay-preview__character-avatar');

        if (character.image) {
            $avatar.append(
                jQuery('<img>', {
                    src: character.image,
                    alt: '',
                    loading: 'lazy',
                    width: 48,
                    height: 48,
                })
            );
        } else {
            $avatar.append(jQuery('<i>', {
                class: 'fa-solid fa-user',
                'aria-hidden': 'true',
            }));
        }

        const $details = jQuery('<span>').addClass('growtype-chat-roleplay-preview__character-details');
        $details.append(jQuery('<span>').addClass('growtype-chat-roleplay-preview__character-title').text(character.title));
        if (character.subtitle) {
            $details.append(jQuery('<span>').addClass('growtype-chat-roleplay-preview__character-subtitle').text(character.subtitle));
        }

        $item.append($avatar, $details);
        if (character.url) {
            $item.append(jQuery('<i>', {
                class: 'fa-solid fa-chevron-right growtype-chat-roleplay-preview__character-arrow',
                'aria-hidden': 'true',
            }));
        }
        $list.append($item);
    });
}

function syncRoleplayPreviewAction($action, url) {
    const hasUrl = typeof url === 'string' && url.trim() !== '';
    $action.attr('href', hasUrl ? url : '#').prop('hidden', !hasUrl);
}

function normalizeRoleplayPreviewData(source = {}) {
    return {
        key: source.key || '',
        title: source.title || 'Roleplay',
        description: source.description || '',
        image: source.image || '',
        characters: source.characters || '[]',
        profileUrl: source.profileUrl || '',
        adjustUrl: source.adjustUrl || '',
        startUrl: source.startUrl || source.profileUrl || '',
    };
}

function getRoleplayPreviewState($modal) {
    return $modal.data('roleplayPreviewState') || {
        items: [],
        activeIndex: 0,
        isLoading: false,
        hasMore: false,
        nextOffset: 0,
        feedKey: '',
        isPrefetching: false,
    };
}

function setRoleplayPreviewState($modal, nextState = {}) {
    const state = {
        ...getRoleplayPreviewState($modal),
        ...nextState,
    };

    $modal.data('roleplayPreviewState', state);
    syncRoleplayPreviewLoading($modal, !!state.isLoading);
    syncRoleplayPreviewNavigation($modal);
}

function syncRoleplayPreviewLoading($modal, isLoading) {
    const $loading = $modal.find('[data-roleplay-preview-loading]').first();
    $loading.prop('hidden', !isLoading);
    $modal.toggleClass('is-roleplay-preview-loading', isLoading);
}

function syncRoleplayPreviewNavigation($modal) {
    const state = getRoleplayPreviewState($modal);
    const canNavigate = !state.isLoading && Array.isArray(state.items) && state.items.length > 1;

    $modal.find('[data-roleplay-preview-nav]').prop('disabled', !canNavigate).attr('aria-hidden', canNavigate ? 'false' : 'true');
}

function fetchRoleplayPreviewFeed($modal, {
    currentKey = '',
    currentPreviewData = null,
    offset = 0,
    cursor = null,
    append = false,
    background = false,
} = {}) {
    const ajaxUrl = $modal.attr('data-roleplay-preview-ajax-url') || '';
    const action = $modal.attr('data-roleplay-preview-feed-action') || '';
    const nonce = $modal.attr('data-roleplay-preview-feed-nonce') || '';

    if (!ajaxUrl || !action) {
        setRoleplayPreviewState($modal, {
            isLoading: false,
            isPrefetching: false,
        });
        return;
    }

    if (background) {
        setRoleplayPreviewState($modal, {
            isPrefetching: true,
        });
    }

    jQuery.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
            action,
            nonce,
            current_key: currentKey,
            offset,
            cursor_order: cursor?.order ?? '',
            cursor_id: cursor?.id ?? '',
            limit: DEFAULT_ROLEPLAY_PREVIEW_FEED_LIMIT,
        },
    }).done(function (response) {
        const feedItems = Array.isArray(response?.data?.items) ? response.data.items : [];
        const currentState = getRoleplayPreviewState($modal);
        const normalizedItems = append
            ? mergeRoleplayPreviewItems(currentState.items, feedItems)
            : createInitialRoleplayPreviewItems(feedItems, currentPreviewData);

        const activeIndex = append
            ? currentState.activeIndex
            : 0;
        const activeItem = normalizedItems[activeIndex] || currentPreviewData;

        setRoleplayPreviewState($modal, {
            items: normalizedItems,
            activeIndex,
            isLoading: false,
            hasMore: response?.data?.has_more === true,
            nextOffset: Number(response?.data?.next_offset || 0),
            nextCursor: response?.data?.next_cursor || null,
            feedKey: currentKey,
            isPrefetching: false,
        });

        if (activeItem) {
            $modal.data('roleplayPreviewData', activeItem);
            syncRoleplayPreviewContent($modal, activeItem);
        }

        ensureRoleplayPreviewPrefetch($modal);
    }).fail(function () {
        setRoleplayPreviewState($modal, {
            isLoading: false,
            isPrefetching: false,
        });
    });
}

function ensureRoleplayPreviewPrefetch($modal) {
    const state = getRoleplayPreviewState($modal);
    const remainingSlides = Math.max(0, (state.items.length - 1) - (state.activeIndex || 0));
    const shouldPrefetchNextBatch = (
        !state.isLoading &&
        !state.isPrefetching &&
        state.hasMore &&
        remainingSlides <= DEFAULT_ROLEPLAY_PREVIEW_FEED_LIMIT
    );

    if (!shouldPrefetchNextBatch) {
        return;
    }

    fetchRoleplayPreviewFeed($modal, {
        currentKey: String(state.feedKey || '').trim(),
        currentPreviewData: null,
        offset: Number(state.nextOffset || state.items.length),
        cursor: state.nextCursor || null,
        append: true,
        background: true,
    });
}

function shiftRoleplayPreview($modal, direction) {
    if (!$modal.length) {
        return;
    }

    const state = getRoleplayPreviewState($modal);
    if (state.isLoading || !Array.isArray(state.items) || state.items.length < 2) {
        return;
    }

    const itemCount = state.items.length;
    const activeIndex = ((state.activeIndex || 0) + direction + itemCount) % itemCount;
    const activeItem = state.items[activeIndex];

    if (!activeItem) {
        return;
    }

    setRoleplayPreviewState($modal, {activeIndex});
    $modal.data('roleplayPreviewData', activeItem);
    syncRoleplayPreviewContent($modal, activeItem);
    ensureRoleplayPreviewPrefetch($modal);
}
